const semanticClassNames = {
  root: 'login-social-bar',
  icons: 'login-social-bar__icons',
  arrowIcon: 'login-social-bar__arrow-icon',
  avatarIcon: 'login-social-bar__avatar-icon',
  dropdownMenu: 'login-social-bar__dropdown-menu',
  greetingText: 'login-social-bar__greeting-text',
} as const;

export default semanticClassNames;
